import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { AuthenticationService } from '../../services/auth.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-trial-product-info',
  templateUrl: './trial-product-info.component.html',
  styleUrls: ['./trial-product-info.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class TrialProductInfoComponent implements OnInit {

  constructor(private authService: AuthenticationService, private router: Router) { }

  ngOnInit() {
  }

  login() {
    this.authService.startAuthentication().then(function () {
    }).catch(function (err) {
      console.log(err);
    });
  }

  startFreeTrial() {
    this.router.navigate(["/registerTrialAccount"]);
  }

}
